<div class="ops-header item-grow" style="display: flex; justify-content: space-between;">
  <a routerLink="/operational-dashboard/component-status">Component Status</a>

  @if (!isLoading && !didError) {
    <div class="tree-buttons">
      <button mat-raised-button color="secondary" (click)="collapseAll()">
        <mat-icon>unfold_less</mat-icon>
        <span>Collapse Tree</span>
      </button>
      <button mat-raised-button color="secondary" (click)="expandAll()">
        <mat-icon>unfold_more</mat-icon>
        <span>Expand Tree</span>
      </button>
    </div>
  }
</div>

@if (isLoading) {
  <insight-loading-spinner [loadingMessage]="'Loading...'">
  </insight-loading-spinner>
}

@if (!isLoading && !didError) {
  <div class="content-box-content">
    <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor" class="tree">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node">
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-icon-button disabled></button>
          {{node.name}}
          <span class="item-grow"></span>
          <div matTooltip="{{node.description}}"
            matTooltipPosition="left"
            matTooltipClass="custom-tooltip"
            style="font-size: 24px;"
             [ngClass]="{
            'status-icon-idle': node.status === componentStatus.Idle,
            'status-icon-ok': node.status === componentStatus.Ok,
            'status-icon-warning': node.status === componentStatus.Warning,
            'status-icon-error': node.status === componentStatus.Error}">
          </div>
        </li>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" [isExpandable]="true" [isExpanded]="true">
        <li>
          <div class="mat-tree-node">
            <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
            {{node.name}}
            @if (node.status !== undefined) {
              <span class="item-grow"></span>
            <div [ngClass]="{
              'status-icon-idle': node.status === componentStatus.Idle,
              'status-icon-ok': node.status === componentStatus.Ok,
              'status-icon-warning': node.status === componentStatus.Warning,
              'status-icon-error': node.status === componentStatus.Error}">
              </div>
            }
          </div>
          <ul [class.tree-invisible]="!tree.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
    @if (componentStatusRawData.length == 0) {
      <span>No component statuses available</span>
    }
  </div>
}

@if (!isLoading && didError) {
  <div class="flex-layout center-content">
    <div>
      An error occurred while getting component status.
    </div>
  </div>
}
